<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="col-md-12">
  <fieldset>
    <legend class="row">
      <div class="col-md-6 m-auto">Customer Contact</div>
      <div class="col-md-6">
        <button
          class="btn btn-primary float-right"
          *ngIf="
            merchant.accountDetails.worldPayAccountDetails
              .backingWPMerchantExists &&
            isUserBase() &&
            isWorldPay() &&
            isMerchantActive() &&
            !editable
          "
          (click)="setEditable(true)"
        >
          <span>
            <fa-icon [icon]="faEditPencil"></fa-icon>
          </span>
          Edit Customer Contact
        </button>
      </div>
    </legend>
    <app-customer-contact
      *ngIf="!editable"
      [merchant]="merchant"
    ></app-customer-contact>
    <div class="mt-3" *ngIf="editable">
      <form
        [formGroup]="customerContactForm"
        name="contact"
        novalidate
        (ngSubmit)="updateCustomerContact()"
      >
        <app-customer-contact-edit
          [contacts]="this.contactsFormGroup"
          [parentGroup]="customerContactForm"
          [merchant]="merchant"
        ></app-customer-contact-edit>
        <app-edit-buttons
          [buttonName]="buttonName"
          [actionInProgress]="actionInProgress"
          [formInvalid]="contactsFormGroup.invalid"
          (editableEvent)="receiveEditEvent($event)"
        ></app-edit-buttons>
      </form>
    </div>
  </fieldset>
</div>
